module.exports = __webpack_public_path__ + "images/plane---aab9939a5d7d970a7778b674bf7afb1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plane.png
// module id = 1026
// module chunks = 0